import { render } from "./SnackAlert.vue?vue&type=template&id=25dd5556"
import script from "./SnackAlert.vue?vue&type=script&lang=js"
export * from "./SnackAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__